import { render, staticRenderFns } from "./TruncateDataWithTooltip.vue?vue&type=template&id=5492bc93"
import script from "./TruncateDataWithTooltip.vue?vue&type=script&lang=js"
export * from "./TruncateDataWithTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports